import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "./Layout/Header";
import { CommonAxiosGet } from "./CommonUtils/CommonAxios";
import { getHighestYear } from "./CommonUtils/CommonGetApis";
import TabsSideBarV2 from "./TabsSideBarV2";
import DCBPopup from "./Components/DCBPopup";
import RevenueDashboard from "./RevenueDashboard";
import SidebarPanchayat from "./sidebarPanchayat";
import { Outlet, useLocation } from "react-router-dom";

function SidebarV2({ children }) {

    const dispatch = useDispatch();
    const RoleId = useSelector((state) => state.reducers?.commonmastersreducer?.dualroles);
    const modulesData = useSelector((state) => state.reducers?.servicedashboardreducer?.modulesSideBarData);

    const [showPopup, setShowPopup] = useState(false);

    const id = Number(RoleId);

    useEffect(() => {
        CommonAxiosGet("property-req-details").then((res) => {
            if (res?.data?.scode === "01") {
                getHighestYear(res?.data?.academicyearmst);
                dispatch({ type: 'NONTAXPROPERTYDETAILS', payload: res?.data });
            }
        });
    }, []);

    /* useEffect(() => {
       const popupShown = sessionStorage.getItem("dcbPopupShown");

       if (!popupShown && [1, 2, 4, 5, 7].includes(id)) {
           setShowPopup(true);
           sessionStorage.setItem("dcbPopupShown", "true");
       }
   }, [id]); */

    const storedData = localStorage.getItem("lastlogin");
    const location = useLocation();

    return (

        <div className="panchayat-dashboard">
            <Header />


            {/* {[1, 2, 4, 5, 7].includes(id) && (
                <DCBPopup show={showPopup} handleClose={() => setShowPopup(false)} />
            )} */}

            <div className="sidebar-container-dashboard mt-4 pt-5">

                {/* DYNAMIC SIDEBAR */}
                <SidebarPanchayat />

                <div className="right-content-dashboard">

                    {
                        !modulesData?.submodule_id ? (

                            <>
                                {[1, 2, 4, 5, 7].includes(id) ? (
                                    <RevenueDashboard />
                                ) : (
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            height: '20vh',
                                            textAlign: 'center'
                                        }}
                                    >
                                        <h5
                                            className="outer-box-text"
                                            style={{
                                                fontSize: '35px',
                                                color: '#2f7f8f'
                                            }}
                                        >
                                            Welcome to Swarna Panchayat...!
                                        </h5>
                                    </div>
                                )}
                            </>

                        ) : location.pathname === "/sidebar" ? (

                            <TabsSideBarV2 />

                        ) : (

                            <Outlet />

                        )
                    }
                </div>

            </div>

            {/* Footer */}
            <div className="panchayat-dashboard-footer">
                <div className="number-visit">
                    {storedData && !isNaN(new Date(storedData)) && (
                        <span>Last login - {new Date(storedData).toLocaleString()}</span>
                    )}
                </div>
                <div className="brand-logo">
                    <p>Designed & Developed by</p>
                    <img src="../img/apcfss.svg" className="img-fluid" alt="apcfss-img" />
                </div>
            </div>

        </div>
    );
}

export default SidebarV2;